<template>
  <v-row>
    <CobroManualDialog v-model="showCobroManual"></CobroManualDialog>
    <PagoManualDialog v-model="showPagoManual"></PagoManualDialog>

    <card-connections-row :cards="cards">
      <template slot="connections-cards" slot-scope="props">
        <card-connections :card-options="props.card"/>
      </template>
    </card-connections-row>

    <v-col class="py-2 px-4 d-flex justify-end align-center" cols="12" v-if="isManualChargeShown">
      <v-btn color="kbGold"
             class="mr-2"
             outlined
             @click="showPagoManual = true">
        {{ $t('general.manualPayment') }}
      </v-btn>

      <v-btn color="kbGold"
             dark
             @click="showCobroManual = true">
        {{ $t('general.manualCollection') }}
      </v-btn>
    </v-col>

    <template v-if="!loadingSuperuserStats">
      <!--<v-col cols="12">
          <RegisterCount :statistics="superUserStatistics"></RegisterCount>
      </v-col>-->

      <v-col cols="12" md="6" lg="6">
        <div class="card-chart kbWhite">
          <LineChart style="height: 200px"
                     :chart-data="usersByDay"
                     :options="chartOptions"
                     ref="lineChart1">
          </LineChart>
        </div>
      </v-col>
      <v-col cols="12" md="6" lg="6">
        <div class="card-chart kbWhite">
          <LineChart style="height: 200px"
                     :chart-data="usersByMonth"
                     :options="chartOptions"
                     ref="lineChart2">
          </LineChart>
        </div>
      </v-col>
      <v-col cols="12">
        <StatsPerApp :statsPerApp="superUserStatistics.infoPerApp"
                     :totalApps="totalApps">
        </StatsPerApp>
      </v-col>
    </template>

    <template v-else>
      <v-col cols="12">
        <v-row class="py-2 px-4" justify="space-between">
          <h4 style="display: inline;">
            {{ $t('general.noDataYet') }}
          </h4>
          <v-spacer/>
        </v-row>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import CobroManualDialog from '@/pages/App/Desktop/CobroManualDialog.vue'
import LineChart from '@/components/chart/LineChart'
import PagoManualDialog from '@/pages/App/Desktop/PagoManualDialog.vue'
import StatsPerApp from '@/pages/App/Desktop/StatsPerApp'
import userTypes from '@/libs/userTypes'
import CardConnections from '@/components/ui/connections/CardConnections'
import CardConnectionsRow from '@/components/ui/connections/CardConnectionsRow'

export default {
  components: { CardConnections, CardConnectionsRow, CobroManualDialog, LineChart, PagoManualDialog, StatsPerApp },
  computed: {
    ...mapGetters(['userType']),
    ...mapState({
      language: state => state.auth.language,
      loadingSuperuserStats: state => state.analytics.loadingSuperuserStats,
      superUserStatistics: state => state.analytics.superUserStats,
      statistics: state => state.apps.statistics,
      isManualChargeShown: state => state.apps.isManualChargeShown
    }),
    cards () {
      if (!this.statistics.count ||
        (this.statistics.count.facebook === undefined && this.statistics.count.instagram === undefined &&
          this.statistics.count.spotify === undefined && this.statistics.count.google === undefined)) return []
      const networkCount = this.statistics.count.facebook + this.statistics.count.instagram +
        this.statistics.count.spotify + this.statistics.count.google
      const total = this.statistics.count.facebook + this.statistics.count.instagram +
        this.statistics.count.spotify + this.statistics.count.google + this.statistics.count.email +
        this.statistics.count.phone + this.statistics.count.imported
      return [
        {
          title: this.$t('general.socialNetworks'),
          amount: networkCount,
          titleIcon: { icon: 'mdi-circle', color: 'kbLightBlue' }
        },
        {
          title: this.$t('general.sentEmails'),
          amount: this.statistics.count.email || 0,
          titleIcon: { icon: 'email', color: 'email', size: '33px' }
        },
        {
          title: this.$t('general.cellphoneRecords'),
          amount: this.statistics.count.phone || 0,
          titleIcon: { icon: 'smartphone', color: 'phone', size: '33px' }
        },
        {
          title: this.$t('general.totalRecords'),
          amount: total,
          titleIcon: { icon: 'mdi-star', color: 'kbGold', size: '33px' }
        }
      ]
    },
    chartOptions () {
      let options = {
        responsive: true,
        maintainAspectRatio: false
      }
      const darkThemeOptions = {
        legend: {
          labels: {
            fontColor: '#c4c4c4'
          }
        },
        scales: {
          yAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }],
          xAxes: [{
            gridLines: {
              color: '#14192A'
            },
            ticks: {
              fontColor: '#c4c4c4'
            }
          }]
        }
      }
      if (this.$vuetify.theme.isDark) {
        options = { ...options, ...darkThemeOptions }
      }
      return options
    }
  },
  created () {
    if (this.userType === userTypes.superadmin.value) {
      this.$store.dispatch('getSuperUserStatistics')
    } else {
      this.$router.push('home')
    }
  },
  data () {
    return {
      totalApps: 0,
      usersByDay: {
        datasets: [{
          backgroundColor: '#f3c788',
          borderColor: '#ffaf5b',
          label: this.$t('general.peoplePerDay'),
          data: [],
          showLine: true
        }],
        labels: []
      },
      usersByMonth: {
        datasets: [{
          backgroundColor: '#f3c788',
          borderColor: '#ffaf5b',
          label: this.$t('general.peoplePerMonth'),
          data: [],
          showLine: true
        }],
        labels: []
      },
      showCobroManual: false,
      showPagoManual: false,
      unlockedManualCharge: 0
    }
  },
  watch: {
    language () {
      this.usersByDay.datasets[0].label = this.$t('general.peoplePerDay')
      this.usersByMonth.datasets[0].label = this.$t('general.peoplePerMonth')
      this.$refs.lineChart1.renderChart(this.usersByDay, this.chartOptions)
      this.$refs.lineChart2.renderChart(this.usersByMonth, this.chartOptions)
    },
    superUserStatistics (value) {
      this.usersByDay.datasets[0].data = []
      this.usersByDay.labels = []
      this.usersByMonth.datasets[0].data = []
      this.usersByMonth.labels = []
      if (value.usersByDay) {
        value.usersByDay.forEach(item => {
          this.usersByDay.datasets[0].data.unshift(item.count)
          this.usersByDay.labels.unshift(`${item.day}/${item.month}/${item.year}`)
        })
      }
      if (value.usersByMonth) {
        value.usersByMonth.forEach(item => {
          this.usersByMonth.datasets[0].data.unshift(item.count)
          this.usersByMonth.labels.unshift(`${item.month}/${item.year}`)
        })
      }
      if (value.infoPerApp) {
        this.totalApps = value.infoPerApp.length
      }
    }
  }
}
</script>
<style scoped>
.small {
  width: 100%;
  max-height: 100px;
}
.card-chart {
  border-radius: 10px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.2);
  padding: 10px;
}
</style>
